<template>
  <div class="app-cards grid">
    <div v-for="project in availableProjects" :key="project.id" class="app-card--client app-card col-12 col-md-6">
      <div class="app-card__text">
        <h2 class="app-card__title">{{ project.name }}</h2>
        <p v-if="project.description" class="app-card__description">{{ project.description }}</p>
      </div>
      <img :src="`/img/client-driver-${imgLocation(project)}.jpg`">
      <div @click="$event.isAction = true" class="dropdown">
        <button class="element-table__actions-button element-button--icon element-button" type="button" data-bs-toggle="dropdown">
          <svg class="element-icon--more-info element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-more-info"></use></svg>
        </button>
        <div class="app-dropdown dropdown-menu dropdown-menu-right">
          <button @click="editProject(project)">
            <svg class="element-icon--edit element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-edit"></use></svg>
            Edit Text
          </button>
          <button class="is--alert" @click="deleteProject(project)">
            <svg class="element-icon--delete element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-delete"></use></svg>
            Delete
          </button>
        </div>
      </div>
      <div class="app-card__buttons">
        <button class="element-button element-button--secondary" @click="navigateToTemplate(project)">Edit Screen Template</button>
        <span
            class="app-tooltip__wrapper"
            @mouseenter="isNotPhoenix(project) ? (showDisabledTooltip = true) : null"
            @mouseleave="showDisabledTooltip = false">
          <button class="element-button element-button--secondary" :disabled="isNotPhoenix(project)" @click="navigateToWhiteLabel(project)">Edit White Label</button>
          <div :class="['app-tooltip', { 'is--open': showDisabledTooltip && isNotPhoenix(project) }]">
              <h4 class="app-tooltip__title">Client-wide white labeling isn't available for this driver.</h4>
          </div>
        </span>
      </div>
    </div>
    <div v-if="createOverlay || isEditing" class="app-modal-dialog app-modal-dialog--create-screen-template">
      <div class="app-modal-dialog__content">
        <div class="app-modal-dialog__header">
          <h4 class="app-modal-dialog__title">{{ isEditing ? 'Edit NODE' : 'New NODE' }}</h4>
        </div>
        <form @submit.prevent="submit" autocomplete="off">
          <div class="app-modal-dialog__body grid">
            <div class="col-12">
              <p>Driver-specific templates allow you to create reusable screen templates and white labels that can be used across clients.</p>
            </div>
            <div class="col-12">
              <div class="input select">
                <label>Driver</label>
                <select name="driver_id" :disabled="isEditing" @change="driverSource = Number($event.target.value)">
                  <option value="" disabled :selected="!driverSource">Select a driver</option>
                  <option v-for="driver in availableDrivers" :key="driver.id" :value="driver.id">{{ driver.name }}</option>
                </select>
              </div>
              <span class="inline-message">Only one template is permitted per driver.</span>
            </div>
            <div class="col-12">
              <div class="input text">
                <label>Name</label>
                <input type="text" name="name" :value="name" @input="name = $event.target.value; nameManuallyEdited = true">
              </div>
            </div>
            <div class="col-12">
              <div class="input textarea">
                <label>Description</label>
                <textarea name="description" :value="description" @input="description = $event.target.value; descriptionManuallyEdited = true"></textarea>
              </div>
            </div>
          </div>
          <div class="app-modal-dialog__footer">
            <button type="button" class="element-button element-button--secondary" @click="close();">Cancel</button>
            <button type="submit" :disabled="!driverSource" class="element-button element-button--primary">{{ isEditing ? 'Save' : 'Create' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'ClientShadowOverlay',
  props: {
    client: {
      type: [String, Array, Object],
      required: true
    },
    drivers: {
      type: Array,
      default () {
        return []
      }
    },
    hiddenProjects: {
      type: Array,
      default () {
        return []
      }
    },
    createOverlay: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: '',
      description: '',
      driverSource: null,
      localProjects: this.hiddenProjects,
      deletedProjectIds: new Set(),
      nameManuallyEdited: false,
      descriptionManuallyEdited: false,
      showDisabledTooltip: false,
      isEditing: false
    }
  },
  methods: {

    imgLocation (project) {
      const driver = this.drivers.find(driver => driver.id === project.driver_id)
      const category = driver.driver.category.toLowerCase()
      return category === 'phoenix' ? 'phoenix' : driver.code.toLowerCase().startsWith('skeleton') ? 'skeleton' : 'default'
    },

    navigateToTemplate (project) {
      window.location.href = `/clients/${this.client.id}/${project.driver_id}/screen-template`
    },
    navigateToWhiteLabel (project) {
      window.location.href = `/clients/${this.client.id}/${project.driver_id}/theme`
    },
    async submit () {
      try {
        const res = await axios.post(`/clients/${this.client.id}/projects`, {
          name: this.name,
          description: this.description,
          driver_id: this.driverSource,
          is_hidden: true
        })
        if (this.isEditing) {
          console.log('Updating project in localProjects:', res.data.data)
          this.localProjects = this.localProjects.map(p => p.id === res.data.data.id ? res.data.data : p)
        } else {
          this.localProjects.push(res.data.data)
        }
        this.name = ''
        this.description = ''
        this.driverSource = null
        this.nameManuallyEdited = false
        this.descriptionManuallyEdited = false
        this.$emit('close')
        this.isEditing = false
      } catch (error) {
        console.error('Failed to create screen template:', error)
      }
    },
    isNotPhoenix (project) {
      return this.drivers.find(driver => driver.id === project.driver_id)?.driver.category !== 'phoenix'
    },
    deleteProject (project) {
      const confirmationInput = prompt(
        `Did you receive the Engagement Partner's approval to irrevocably delete "${project.name}"? If yes, please enter the project name to confirm.`,
        ''
      )
      if (confirmationInput === null) return
      if (confirmationInput !== project.name) {
        alert('You must enter the correct project name to proceed with deletion.')
        return
      }
      if (!confirm('Are you sure? This cannot be undone.')) return
      axios.post(`/projects/${project.id}`,{_token: this.$store.state.csrfToken, _method: 'DELETE', force: '1'})
          .then(() => {
            this.localProjects = this.localProjects.filter(p => p.id !== project.id)
            this.deletedProjectIds = new Set([...this.deletedProjectIds, project.id])
          })
          .catch(error => {
            console.error('Failed to delete project:', error)
          })
    },
    editProject (project) {
      this.name = project.name
      this.description = project.description
      this.driverSource = project.driver_id
      this.isEditing = true
    },
    close () {
      this.name = ''
      this.description = ''
      this.nameManuallyEdited = false
      this.descriptionManuallyEdited = false
      this.driverSource = null
      this.isEditing = false
      this.$emit('close')
    },
  },
  computed: {
    availableProjects () {
      return [...this.localProjects].filter(p => !this.deletedProjectIds.has(p.id))
    },
    availableDrivers () {
      if(this.isEditing) {
        return this.drivers
      }
      const usedDriverIds = new Set(this.availableProjects.map(p => p.driver_id))
      return this.drivers.filter(d => !usedDriverIds.has(d.id))
    },
    selectedDriver () {
      return this.drivers.find(driver => driver.id === this.driverSource) || null
    }
  },
  watch: {
    selectedDriver (driver) {
      if (this.isEditing) return
      if (driver) {
        if (!this.nameManuallyEdited) {
          this.name = `${this.client.name} - ${driver.name}`
        }
        if (!this.descriptionManuallyEdited) {
          this.description = driver.description || ''
        }
      } else {
        if (!this.nameManuallyEdited) {
          this.name = this.client.name
        }
        if (!this.descriptionManuallyEdited) {
          this.description = ''
        }
      }
    }
  },
  mounted () {
    this.name = this.client.name
    this.description = ''
    this.driverSource = null
    this.nameManuallyEdited = false
    this.descriptionManuallyEdited = false
  }

}
</script>
